import { Route } from "react-router-dom";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import ModernSlaveryPage from "@/pages/ModernSlaveryPage";
import TermsPage from "@/pages/TermsPage";
import ICOCertificatePage from "@/pages/ICOCertificatePage";
import BusinessInsurancePage from "@/pages/BusinessInsurancePage";
import PSRQuotationToolPage from "@/pages/PSRQuotationToolPage";
import PaymentTermsPage from "@/pages/PaymentTermsPage";

export default function LegalRoutes() {
  return (
    <>
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="/modern-slavery-statement" element={<ModernSlaveryPage />} />
      <Route path="/terms-and-conditions" element={<TermsPage />} />
      <Route path="/ico-certificate" element={<ICOCertificatePage />} />
      <Route path="/business-insurance" element={<BusinessInsurancePage />} />
      <Route path="/psr-quotation-tool" element={<PSRQuotationToolPage />} />
      <Route path="/payment-industry-terms" element={<PaymentTermsPage />} />
    </>
  );
}
